import * as React from "react";
const SvgFiRrSunDust = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-sun-dust_svg__a)">
      <path
        fill="#062147"
        d="M17 22.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 17 22.5M22.5 10a1.5 1.5 0 1 0-.001-3.001A1.5 1.5 0 0 0 22.5 10m-14 11a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 21m14 0a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 22.5 21m0-6.97a1.5 1.5 0 1 0 .001 3.001 1.5 1.5 0 0 0-.001-3.001M19 17.5a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 19 17.5m-7 0a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 12 17.5m3.5-3.5a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 15.5 14m3.5-3.5a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 19 10.5M7.05 17.95a.999.999 0 0 0 .707-1.707A5.96 5.96 0 0 1 6 12c0-1.603.624-3.109 1.757-4.243a6.01 6.01 0 0 1 8.486 0 .999.999 0 1 0 1.414-1.414 8 8 0 0 0-.812-.699l1.542-2.652a1 1 0 1 0-1.728-1.006l-1.542 2.651A8 8 0 0 0 13 4.073V1a1 1 0 1 0-2 0v3.074a8 8 0 0 0-2.106.558L7.355 1.986a.997.997 0 0 0-1.367-.361 1 1 0 0 0-.361 1.367l1.538 2.645a8 8 0 0 0-.822.706 8 8 0 0 0-.688.797L3.004 5.597a1 1 0 0 0-1.367.361 1 1 0 0 0 .361 1.368l2.647 1.541A8 8 0 0 0 4.074 11H1a1 1 0 1 0 0 2h3.073c.091.727.278 1.443.568 2.127l-2.638 1.535a.999.999 0 1 0 1.006 1.728l2.641-1.537c.213.278.438.549.693.803a1 1 0 0 0 .707.293z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-sun-dust_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSunDust;
